
import { Facet } from '../models/Facet';

/**
 * Facet which indicates that an item has child items and provides
 * an ordering of their keys.
 */
export const childItemsFacet: Facet<{
  itemKeys: string[];
}> = new Facet('childItems');

/**
 * Facet which indicates that an itemset has a schema and
 * provides the columns in the schema
 */
export const schemaFacet: Facet<{
  columnKeys: string[];
}> = new Facet('schema');

/**
 * Facet which indicates that an item has child item sets
 * and which provides a default item set key.
 */
export const defaultChildItemSetFacet: Facet<{
  itemKey: string;
}> = new Facet('defaultChildItemSet');

/**
 * Facet which indicates that an item has child item sets
 * and provides a way to access them.
 *
 * @deprecated Use defaultChildItemSetFacet instead.
 */
export const childItemSetsFacet: Facet<{
  default: {
    itemKey: string;
  };
}> = new Facet('childItemSets');

/**
 * Facet which indicates which item owns an item set.
 */
export const parentItemFacet: Facet<{
  itemKey: string;
}> = new Facet('parentItem');

/**
 * Facet which indicates to which item sets a given item has been attached.
 */
export const parentItemSetsFacet: Facet<{
  itemSets: {
    [itemKey: string]: {};
  };
}> = new Facet('parentItemSets');

/**
 * Facet which indicates that an item represents a page, and is thus
 * a placeholder for more items.
 */
export const pageFacet: Facet<{}> = new Facet('page');

/**
 * Facet which indicates that an itemset can be filtered and
 * provides filterOptionSet key for each filterable column.
 */
export const filterOptionSetsFacet: Facet<{
  [columnKey: string]: string;
}> = new Facet('filterOptionSets');

/**
 * Facet which indicates the column key and the direction by which the child items of the item set are sorted.
 */
export const sortFacet: Facet<{
  columnKey: string;
  isAscending: boolean;
}> = new Facet('sort');